// Static geo data — kept in sync with backend /api/compass/geo
export const COUNTRY_FLAGS = {
  Argentina: "🇦🇷",
  Bolivia: "🇧🇴",
  Chile: "🇨🇱",
  Colombia: "🇨🇴",
  "Costa Rica": "🇨🇷",
  Cuba: "🇨🇺",
  Ecuador: "🇪🇨",
  "El Salvador": "🇸🇻",
  España: "🇪🇸",
  "Estados Unidos": "🇺🇸",
  Guatemala: "🇬🇹",
  Honduras: "🇭🇳",
  México: "🇲🇽",
  Nicaragua: "🇳🇮",
  Panamá: "🇵🇦",
  Paraguay: "🇵🇾",
  Perú: "🇵🇪",
  "Puerto Rico": "🇵🇷",
  "República Dominicana": "🇩🇴",
  Uruguay: "🇺🇾",
  Venezuela: "🇻🇪",
};

export const READINESS_COLORS = {
  verde:    { bg: "#2A9D8F", label: "Listo para Comenzar" },
  amarillo: { bg: "#FCA311", label: "Requiere Preparación" },
  naranja:  { bg: "#F77F00", label: "Validar Antes de Invertir" },
  rojo:     { bg: "#E63946", label: "Alto Riesgo" },
};

// Colors for score chips (green good, yellow medium, red high/hard)
export const SCORE_TONE = {
  potencial_ingresos: { bajo: "#8A8A8A", medio: "#FCA311", alto: "#2A9D8F" },
  capital_requerido:  { bajo: "#2A9D8F", medio: "#FCA311", alto: "#E63946" },
  complejidad:        { "fácil": "#2A9D8F", moderada: "#FCA311", "difícil": "#E63946" },
  riesgo:             { bajo: "#2A9D8F", medio: "#FCA311", alto: "#E63946" },
  mercado:            { "fácil": "#2A9D8F", moderado: "#FCA311", "difícil": "#E63946" },
  preparacion:        { alto: "#2A9D8F", medio: "#FCA311", bajo: "#E63946" },
};
